export default "__VITE_ASSET__B70VgwLe__"